import * as React from "react";
import { AnimatePresence, motion } from "motion/react";
import { useClearRefinements } from "react-instantsearch";
import { ButtonDropdown } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useFacetLabel } from "../../../../../hooks/Algolia/hooks/use-facet-label.js";
import { useSearchableRefinementList } from "../../../../../hooks/Algolia/hooks/use-searchable-refinement-list.js";
import { ClearFacetFilter } from "../../../../ClearFacetFilter/Algolia/components/ClearFacetFilter/ClearFacetFilter.js";
import FacetContainer from "../../../../FacetContainer/Algolia/components/FacetContainer/FacetContainer.js";
import { FacetSearchBox } from "../../../../FacetSearchBox/Algolia/components/FacetSearchBox/FacetSearchBox.js";
import RefinementItem from "../../../../RefinementItem/Algolia/components/RefinementItem/RefinementItem.js";
/* empty css                             */
const facetInputItemVariants = {
  flip: {
    transition: {
      type: "spring",
      stiffness: 500,
      damping: 800
    }
  }
};
function ConnectedFacetInputList({ facet }) {
  const { getLabel } = useIntl();
  const { isFromSearch, sortedItems, refine, setQuery } = useSearchableRefinementList({
    facet
  });
  const label = useFacetLabel({ facet });
  const { refine: clearRefine } = useClearRefinements({ includedAttributes: [facet.attribute] });
  const refineCount = sortedItems.filter((item) => item.isRefined).length;
  const ariaLabel = `${getLabel("search.filterBy")} ${label.toLowerCase()}`;
  if (!sortedItems.length && !isFromSearch) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ButtonDropdown,
    {
      focusItemOnHover: false,
      loop: true,
      "aria-label": ariaLabel,
      className: "connected-facet-input-list"
    },
    /* @__PURE__ */ React.createElement(ButtonDropdown.Button, { popupType: "dialog", className: "connected-facet-input-list__button" }, label),
    /* @__PURE__ */ React.createElement(ButtonDropdown.Content, { type: "generic", restoreFocus: true }, /* @__PURE__ */ React.createElement(
      FacetContainer,
      {
        SearchButton: facet.searchable ? /* @__PURE__ */ React.createElement(ButtonDropdown.InteractiveWrapper, { childElement: "input" }, /* @__PURE__ */ React.createElement(
          FacetSearchBox,
          {
            className: "connected-facet-input-list__search",
            onSearch: setQuery
          }
        )) : void 0,
        ClearButton: /* @__PURE__ */ React.createElement(ButtonDropdown.InteractiveWrapper, { isDisabled: refineCount <= 0, childElement: "button" }, /* @__PURE__ */ React.createElement(
          ClearFacetFilter,
          {
            onClear: clearRefine,
            isDisabled: refineCount <= 0,
            label: getLabel("search.filters.clear", {
              defaultValue: "clear"
            })
          }
        )),
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, refineCount, " ", getLabel("search.filters.selected", {
          defaultValue: "selected"
        }))
      },
      /* @__PURE__ */ React.createElement(AnimatePresence, null, sortedItems.map((item) => /* @__PURE__ */ React.createElement(ButtonDropdown.InteractiveWrapper, { key: item.label, childElement: "input" }, /* @__PURE__ */ React.createElement(motion.div, { variants: facetInputItemVariants, key: item.label }, /* @__PURE__ */ React.createElement(RefinementItem, { key: item.label, item, facet, onRefine: refine })))))
    ))
  );
}
export {
  ConnectedFacetInputList
};
//# sourceMappingURL=ConnectedFacetInputList.js.map
